import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface IHolderDataFormMeta {
    title: FormInputMeta;
    holderFirstName: FormInputMeta;
    name2: FormInputMeta;
    name: FormInputMeta;
    nameOnCard: FormInputMeta;
    socialReason: FormInputMeta;

}

const holderDataFormMeta = {} as IHolderDataFormMeta;

holderDataFormMeta.title = {
    name: "title",
    type: "select",
    label: "Titre",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

holderDataFormMeta.holderFirstName = {
    name: "holderFirstName",
    type: "text",
    label: "Prénom Porteur",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

holderDataFormMeta.name2 = {
    name: "name2",
    type: "text",
    label: "Nom",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

holderDataFormMeta.name = {
    name: "name",
    type: "text",
    label: "Nom",
    placeholder: "",
    validation: yup.string()
};

holderDataFormMeta.nameOnCard = {
    name: "nameOnCard",
    type: "text",
    label: "Nom Sur Carte",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

holderDataFormMeta.socialReason = {
    name: "socialReason",
    type: "text",
    label: "Raison Sociale",
    placeholder: "",
    validation: yup.string()
};

export default holderDataFormMeta;